import React from 'react';
import formateText from '../../../utils/Formate';

const SetupTittle = ({text}) => {
    return (
        <h1 className="xl:text-5xl lg:text-4xl text-3xl font-bold mb-8 lg:mb-[64px]">{formateText(text)}</h1>
    );
};

export default SetupTittle;
